import { combineReducers } from 'redux-immutablejs';

import globalReducer from './global';
import searchReducer from './search';
import companyReducer from './company';

export default combineReducers({
  global: globalReducer,
  search: searchReducer,
  company: companyReducer,
});
